module.exports = __webpack_public_path__ + "static/media/mt11.63e1cc0a.png";